import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as API from "../endpoint";
import Header from "../pages/header";
import Footer from "../pages/footer";

const VulnerabilityTable = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  const loadData = async () => {
    const response = await axios.get(API.GET_VULNERABILITY_API);
    setData(response.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  const deleteObject = async (vulnerabilityid) => {
    if (window.confirm("Are you sure you want to delete")) {
      await axios.delete(API.DELETE_VULNERABILITY_API(vulnerabilityid));
      console.log("success:", "deleted successfully");
      loadData();
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <Header />
      <div style={{ marginTop: "10px", marginBottom: "3cm" }}>
        <Link to="/addvulnerability">
          <center>
            <button className="btn btn-contact">Add Vulnerability</button>
          </center>
        </Link>

        <table className="styled-table" width="1500px">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>No</th>
              <th style={{ textAlign: "center" }}>Vulnerability Name</th>
              <th style={{ textAlign: "center" }}>Threat</th>
              <th style={{ textAlign: "center" }}>Mitigation Strategy</th>
              <th style={{ textAlign: "center" }}>Contigency Plan</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr key={item.id}>
                <th scope="row">{index + 1}</th>
                <td>{item.vulnerabilityname}</td>
                <td>{item.threat}</td>
                <td>{item.mitigationstrategy}</td>
                <td>{item.contigencyplan}</td>
                <td>
                  <Link to={`/vulnerabilityupdate/${item.vulnerabilityid}`}>
                    <button className="btn btn-edit">Edit</button>
                  </Link>
                  <button
                    className="btn btn-delete"
                    onClick={() => deleteObject(item.vulnerabilityid)}
                  >
                    Delete
                  </button>
                  <Link to={`/vulnerabilityView/${item.vulnerabilityid}`}>
                    <button className="btn btn-view">View</button>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <center>
          <div className="pagination">
            {Array.from(
              { length: Math.ceil(data.length / itemsPerPage) },
              (_, i) => (
                <button key={i + 1} onClick={() => paginate(i + 1)}>
                  {i + 1}
                </button>
              )
            )}
          </div>
        </center>
      </div>
      <Footer />
    </div>
  );
};

export default VulnerabilityTable;
